import { isHotel, offerTypeFromJsonQuery } from './category';
import { IJsonQuery } from '../repositories/common/json_query';

// Хак для отелей, они хранятся в RentDaily и отображаются только с параметром show_hotels=true
export function checkIsHotelsSearch(jsonQuery: IJsonQuery) {
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  return isHotel(offerType);
}
